export default __webpack_public_path__ + "static/media/signup.d4a0832e.png";